import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Box1Component } from "src/app/fitur-26/layout/boxes";
import { Card1Component } from "src/app/fitur-26/layout/cards";
import { TranslationService } from 'src/app/services';
import { Suggestion } from './services';
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { JsonPipe } from '@angular/common';
import { Multimedia } from './interfaces';


@Component({
  selector: 'app-suggestions',
  standalone: true,
  imports: [
    TranslateModule,
    Box1Component, 
    Card1Component
  ],
  templateUrl: './suggestions.component.html',
  styleUrls: ['./suggestions.component.scss'],
  host: {
    style: `display: flex; 
            justify-content: center; 
            align-items: center; 
            width: 1100px; 
            height: 100%;
            margin: 0 auto;
          `
  }
})
export class SuggestionsComponent {
  private _router = inject(Router);
  private _translationService = inject(TranslationService);
  private _suggestionService = inject(Suggestion);
  private _customRouteService = inject(CustomRouteService);
  
  protected selectedLanguage = this._translationService.selectedLanguage;
  private _routeToken = this._customRouteService.token;
  protected suggestionList = this._suggestionService.suggestionList;

  protected goToDetailPage(pointId: number, pointType: string, from: string): void {
    const typeNormalized = pointType === 'event' ? 'event' : 'point';
    
    this._router.navigate(
      ['/home', typeNormalized, pointId], 
      { queryParams: { from } }
    );
  }
  
  getSuggestionList = effect(() => {
    const routeToken = this._routeToken();
    if (!routeToken) return;
    
    this._suggestionService.getEventDetailsServiceSignal(routeToken);
  }, { allowSignalWrites: true });
  
  protected getFirstImageFromMultimediaList(multimediaList: Multimedia[]): string {
    const imageItem = multimediaList.find(item => item.type === 'image');
    return imageItem ? imageItem.name : '';
  }
}
